import axios from "axios";
import {db_url, url_trade_point, url_trade_point_filter} from "../url";

export default function DB_TradePoint (token) {
    const url = '/dictionary/trade_point'
    const url_s = '/dictionary/trade_points'

    const formData = new FormData;
    formData.append('token', token);

    const appendToken = (data) => {
        const fd = new FormData;
        for (const pair of data.entries()) {
            fd.append(pair[0], pair[1]);
        }
        fd.append('token', token);
        return fd
    }


    const getTradePoints = (controller, search) => {
        return axios.get(db_url + '/dictionary/trade_points', {
            signal: controller.signal,
            params: search,
            headers: {
                Authorization: token
            }
        })
    }

    const getTradePoint = (id) => {
        // return axios.get("http://127.0.0.1:3002/api_web/v1" + '/dictionary/trade_point',  {
        return axios.get(db_url + url,  {
            params: {
                id: id
            },
            headers: {
                Authorization: token
            }
        })
    }

    const updateTradePoint = (data) => {
        return axios.put(url_trade_point, appendToken(data))
    }

    const getTradePointsForOrgStructure = (branch_id, org_structure_id) => {
        return axios.get(db_url + url_s + '/org_structure', {
        // return axios.get("http://127.0.0.1:3002/api_web/v1" + url_s + '/org_structure', {
            params: {
                branch_id: branch_id,
                org_structure_id: org_structure_id
            },
            headers: {
                Authorization: token
            }
        })
    }

    async function getTradePointFilter(t_point, branch) {

        let params = {
            name: t_point
        }
        if (branch != null) {
            params = {
                branch_id: branch,
                name: t_point
            }
        }

        return new Promise(resolve => {
            axios.get(url_trade_point_filter, {
                params: params,
                headers: {
                    Authorization: token
                }
            })
                .then(res => {
                    const data = res.data.map(t => (
                        {
                            label: t.name,
                            value: t.id
                        }
                    ))
                    resolve(data)
                })
        })
    }

    const tradePointResponsePerson = (org_structure_id, branch_id, show_all) => {
        // return axios.get("http://127.0.0.1:3002/api_web/v1" + url + '/response', {
        return axios.get(db_url + url_s + '/response', {
            params: {
                branch_id: branch_id,
                org_structure_id: org_structure_id,
                show_all: show_all
            },
            headers: {
                Authorization: token
            }
        })
    }

    const saveTradePointResponsePerson = (org_structure_id, branch_id, data) => {
        // return axios.put("http://127.0.0.1:3002/api_web/v1" + url + '/response', data, {
        return axios.put(db_url + url_s + '/response', data, {
            params: {
                branch_id: branch_id,
                org_structure_id: org_structure_id,
            },
            headers: {
                Authorization: token,
                'Content-Type': 'application/json'
            }
        })
    }

    return {
       getTradePoints,
        getTradePoint,
        updateTradePoint,
        getTradePointsForOrgStructure,
        getTradePointFilter,
        tradePointResponsePerson,
        saveTradePointResponsePerson
    }
}
